import standardAPI from '@/api/standard_items';

const responseUrl = '/hotels/transfers';

const state = {
  transfers: [],
  transfers_MetaData: {},
  transfers_status: '',
  transfers_page: 1,
  transfers_perPage: 10,
};

const getters = {
  get_transfers: (state) => {
    return state.transfers;
  },
  get_transfers_status: (state) => {
    return state.transfers_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_transfers ({ commit }, getOptions) {
    commit('DATA_TRANSFERS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_TRANSFERS_UPDATE_SUCCESS', response);
            commit('DATA_TRANSFERS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_TRANSFERS_READY');
            reject(response);
          } else {
            commit('DATA_TRANSFERS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_transfers_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_transfer ({ commit, dispatch }, itemData) {
    commit('DATA_TRANSFERS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_TRANSFERS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_TRANSFERS_READY');
          reject(response);
        }
      });
    });
  },
  edit_transfer ({ commit, dispatch }, itemData) {
    commit('DATA_TRANSFERS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_TRANSFERS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_TRANSFERS_READY');
          reject(response);
        }
      });
    });
  },
  remove_transfers ({ commit, dispatch }, itemData) {
    commit('DATA_TRANSFERS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_TRANSFERS_REQUEST');
          resolve();
        } else {
          commit('DATA_TRANSFERS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_transfer ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_transfer_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.transfers_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.transfers_perPage = max;
  },
  DATA_TRANSFERS_READY: (state) => {
    state.transfers_status = 'ready';
  },
  DATA_TRANSFERS_REQUEST: (state) => {
    state.transfers_status = 'loading';
  },
  DATA_TRANSFERS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.transfers_MetaData.meta = response.meta;
      state.transfers_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.transfers = response.data || [];
    }
    state.transfers_status = 'success';
  },
  DATA_TRANSFERS_ERROR: (state) => {
    state.transfers_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
